import React from 'react';
import { playaudio, getaudio } from '../../common/functions';
import './PostGameScreen.css';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
export function Postgame(props) {
    function check(elem) {
        if (elem.guessedCorrect)
            return React.createElement(CheckIcon, { sx: { color: 'green', fontSize: 30 } });
        else
            return React.createElement(ClearIcon, { sx: { color: 'red', fontSize: 30 } });
    }
    return (React.createElement("div", { className: "postGameScreen" },
        React.createElement("h2", null, "Results"),
        React.createElement("ul", null, props.elements.map(function (item) { return (React.createElement("li", { className: "postGameElement", key: item.audio },
            React.createElement("button", { className: "postgame_audio" },
                React.createElement(VolumeUpIcon, { sx: { fontSize: 40, color: '#d66d27' }, onClick: function () { return playaudio(getaudio(item.audio)); } })),
            React.createElement("p", { className: "postGameWord postGameWord_eng" }, item.word),
            React.createElement("p", { className: "postGameWord" }, item.correctTranslate),
            React.createElement("p", null, check(item)))); })),
        React.createElement("button", { className: "again", onClick: function () { return props.func(); } },
            ' ',
            "Play Again")));
}
